import React from "react";

type ConfirmDialogProps = {
  title?: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  title = "Atenção!",
  message,
  onConfirm,
  onCancel,
}) => {
  return (
    <div style={{
      position: "fixed",
      top: 0, left: 0,
      width: "100vw", height: "100vh",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex", alignItems: "center", justifyContent: "center",
      zIndex: 9999
    }}>
      <div style={{
        backgroundColor: "#FFF",
        padding: 24,
        borderRadius: 12,
        minWidth: 300,
        display: "flex",
        flexDirection: "column",
        gap: 16
      }}>
        <h3>{title}</h3>
        <p style={{fontSize: 14}}>{message}</p>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <button
            onClick={onCancel}
            style={{ background: "#ccc", padding: '12px 16px', borderRadius: 8, fontSize: 16 }}
          >
            <span style={{fontWeight: 'bold', fontSize: 16, color: "#FFF"}}>Cancelar</span>
          </button>
          <button
            onClick={onConfirm}
            style={{ background: "#FF5500", padding: '12px 16px', borderRadius: 8 }}
          >
            <span style={{fontWeight: 'bold', fontSize: 16, color: "#FFF"}}>Remover</span>
          </button>
        </div>
      </div>
    </div>
  );
};
